export function getInitials(name?: string | null, fallback = 'U'): string {
	if (!name) return fallback;
	const parts = name.trim().split(/\s+/).filter(Boolean);
	if (parts.length === 0) return fallback;
	if (parts.length === 1) return parts[0]![0]!.toUpperCase();
	return (parts[0]![0]! + parts[parts.length - 1]![0]!).toUpperCase();
}
